import BlockRegistry from '../../BlockRegistry';

export function registerIRSensor() {
    BlockRegistry.register('irSensor_irReadDigital', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addSetup(`pinMode(${pin}, INPUT);`);
        // IR sensor digital out is LOW when object detected
        return `(digitalRead(${pin}) == LOW)`;
    });
    BlockRegistry.registerPython('irSensor_irReadDigital', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addInclude('from machine import Pin');
        context.addSetup(`pin_${pin} = Pin(${pin}, Pin.IN)`);
        return `(pin_${pin}.value() == 0)`;
    });

    BlockRegistry.register('irSensor_irReadAnalog', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        return `analogRead(${pin})`;
    });
    BlockRegistry.registerPython('irSensor_irReadAnalog', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addInclude('from machine import Pin, ADC');
        context.addSetup(`adc_${pin} = ADC(Pin(${pin}))`);
        return `adc_${pin}.read_u16()`;
    });

    BlockRegistry.register('irSensor_irWaitDetect', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addSetup(`pinMode(${pin}, INPUT);`);
        return `while (digitalRead(${pin}) == HIGH) { delay(10); }`;
    });
    BlockRegistry.registerPython('irSensor_irWaitDetect', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        context.addInclude('from machine import Pin\nimport time');
        context.addSetup(`pin_${pin} = Pin(${pin}, Pin.IN)`);
        return `while pin_${pin}.value() == 1:\n    time.sleep_ms(10)`;
    });
}
